import { useEffect, useState } from 'react'
import { ArrowUpRight, Menu, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useLocalPathname } from '../i18n/Link'
import LanguageSwitcher from '../i18n/LanguageSwitcher'

export default function Navbar() {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)
  const pathname = useLocalPathname()
  const links = [
    [t('nav.product'), '/features'],
    [t('nav.solutions'), '/enterprise'],
    [t('nav.pricing'), '/pricing'],
    [t('nav.resources'), '/docs'],
  ] as const
  useEffect(() => {
    setOpen(false)
  }, [pathname])
  useEffect(() => {
    const close = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, [])
  return (
    <header className="site-header">
      <nav className="site-nav" aria-label={t('nav.main')}>
        <Link to="/" className="wordmark" aria-label={t('nav.home')}>
          <img src="/brand/mark.svg" alt="" width="32" height="32" />
          <span className="brand-lockup">
            <strong>{t('brand.name')}</strong>
            <small>{t('brand.tagline')}</small>
          </span>
        </Link>
        <div className="desktop-links">
          {links.map(([label, path]) => (
            <Link key={path} to={path} aria-current={pathname === path ? 'page' : undefined}>
              {label}
            </Link>
          ))}
        </div>
        <div className="nav-actions">
          <LanguageSwitcher compact />
          <Link className="nav-contact" to="/contact">
            {t('nav.contact')}
          </Link>
          <Link className="jade-button small" to="/download">
            {t('nav.start')} <ArrowUpRight size={16} />
          </Link>
        </div>
        <button
          className="mobile-toggle"
          aria-label={open ? t('nav.closeMenu') : t('nav.openMenu')}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </nav>
      {open && (
        <nav id="mobile-navigation" className="mobile-navigation" aria-label={t('nav.mobile')}>
          {links.map(([label, path]) => (
            <Link key={path} to={path}>
              {label}
              <ArrowUpRight size={16} />
            </Link>
          ))}
          <Link to="/contact">{t('nav.contact')}</Link>
          <Link className="jade-button" to="/download">
            {t('nav.start')} <ArrowUpRight size={16} />
          </Link>
          <div className="mobile-lang">
            <LanguageSwitcher />
          </div>
        </nav>
      )}
    </header>
  )
}
